import { createFileRoute } from '@tanstack/react-router'
import { WalkdownDetails } from 'pages/walkdown/WalkdownDetails'

export const Route = createFileRoute('/walkdowns/$siteID/$walkdownId')({
  component: WalkdownDetails,
  staticData: {
    title: 'Walkdown Details',
  },
  validateSearch: (search: Record<string, unknown>) => {
    return search
  },
})
